<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Add Integration'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    <ng-container>

      @if (loaded) {
        <tidy-alert>
          <form [formGroup]="form" novalidate action="#">
            <tidy-row class="field-top-padding" style="padding-bottom:0px">
              <tidy-input
                #searchInput
                [icon]="'assets/svg/search.svg'"
                [noBorder]="true"
                type="search"
                formControlName="search"
                [label]="'Search'"
                [form]="form" />
            </tidy-row>
          </form>
        </tidy-alert>
        @for (option of integrationOptions; track option) {
          <tidy-card>
            <tidy-card-button (action)="goToAddIntegration(option)" class="no-below-stroke">
              <tidy-image
                [src]="option.logo_url"
                style="width:70%; height:30px" />
            </tidy-card-button>
            @if (option.short_description !== null) {
              <tidy-row>
                <tidy-text
                  [body]="option.short_description" />
              </tidy-row>
            }
          </tidy-card>
        }
      }

      @if (!loaded) {
        <tidy-alert style="height:69px" />
        <tidy-card>
          <tidy-card-button [hideArrow]="true" class="no-below-stroke">
            <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
          </tidy-card-button>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 100%" />
            <ion-skeleton-text animated="true" style="width: 100%" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-card-button [hideArrow]="true" class="no-below-stroke">
            <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
          </tidy-card-button>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 100%" />
            <ion-skeleton-text animated="true" style="width: 100%" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-card-button [hideArrow]="true" class="no-below-stroke">
            <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
          </tidy-card-button>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 100%" />
            <ion-skeleton-text animated="true" style="width: 100%" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-card-button [hideArrow]="true" class="no-below-stroke">
            <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
          </tidy-card-button>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 100%" />
            <ion-skeleton-text animated="true" style="width: 100%" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-card-button [hideArrow]="true" class="no-below-stroke">
            <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
          </tidy-card-button>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 100%" />
            <ion-skeleton-text animated="true" style="width: 100%" />
          </tidy-row>
        </tidy-card>
        <tidy-card>
          <tidy-card-button [hideArrow]="true" class="no-below-stroke">
            <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
          </tidy-card-button>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 100%" />
            <ion-skeleton-text animated="true" style="width: 100%" />
          </tidy-row>
        </tidy-card>
      }

    </ng-container>
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
